import { render, staticRenderFns } from "./VineyardQuestionEditor.vue?vue&type=template&id=1befdb33&scoped=true&"
import script from "./VineyardQuestionEditor.vue?vue&type=script&lang=js&"
export * from "./VineyardQuestionEditor.vue?vue&type=script&lang=js&"
import style0 from "./VineyardQuestionEditor.vue?vue&type=style&index=0&id=1befdb33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1befdb33",
  null
  
)

export default component.exports